import Vue from 'vue'
import Vuex from 'vuex'

import trialOptions from './modules/trialOptions'
import projectFields from './modules/projectFields'
import paramsData from './modules/paramsData'
import projects from './modules/projects'
import Api from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    error: "",
    organisationTokens: 0,
    trialToShowInResultsCrumb: -1,
    user: {}
  },
  mutations: {
    postError: (state, payload) => {
      state.error = payload
    },
    updateTokens: (state, payload) => {
      state.organisationTokens = payload
    },
    storeUser: (state, payload) => {
      state.user = payload
    }
  },
  actions: {
    setError: (context, error) => {
      context.commit("postError", error.response.data.detail)
    },
    async updateOrganisationTokens(context) {
      let tokens = await Api.getOrganisationTokens()
      context.commit("updateTokens", tokens)
    },
    async storeUser(context) {
      let user = await Api.getUser()
      context.commit("storeUser", user)
    },
  },
  modules: {
    trialOptions,
    projectFields,
    paramsData,
    projects
  }
})
